<!--
Author: XiangChenYu
Date: 2019-11-06
Desc: 热门高端理财基金
 -->
<template>
    <div v-show="fund.length>0" :class="'view-private-hot view-border bg-white view ' + className">
        <comp-title v-if="fund.length<4" :title="title" />
        <hot-tab v-if="fund.length>3" :private-val="true" :fund-info="fund" v-on:fund-continue="fundBuy" />
        <fund-list v-else :fund-info="fund" :is-hot="true" v-on:fund-continue="fundBuy" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import hotTab from "@/components/fund/hotTab";
import fundList from "@/components/fund/fundList";
export default {
    name: "PrivateHot",
    components: {
        hotTab,
        fundList
    },
    mixins: [mixin],
    data () {
        return {
            allFund: [],
            user: {},
            fund: []
        };
    },
    watch: {
        "$store.state.user.qryallfund"(val){
            this.getFund(val);
        }
    },
    created () {
        this.user = this.$cache.getUser();
        this.getHotFund();
    },
    methods: {
        getHotFund () {
            this.$util.request("pef/trade/recommend").then(res => {
                if (res.data) {
                    this.allFund = res.data;
                    this.getFund(this.user.qryallfund || "");
                }
            });
        },
        getFund(val){
            if(val === "0"){
                const _this = this;
                this.fund = this.allFund.filter(item=>{
                    return item.risklevel <= _this.user.custrisk;
                });
            }else{
                this.fund = this.allFund;
            }
        },
        fundBuy (way, val) {
            let _url = "";
            if (way === "20,22") {
                _url = "privatebuy";
            }
            val.proto = "buy";
            this.$util.fundRiskCheck(this, val, res => {
                if (res) {
                    const _x = Object.assign({}, res, { way: way });
                    sessionStorage.setItem(_url, JSON.stringify(_x));
                    this.$router.push({ name: _url, query: { fundcode: res.fundcode } });
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.view-private-hot {
    overflow: hidden;
    .comp-fund-list {
        padding: 10px 20px;
        .el-table--fit {
            margin: 0;
        }
    }
}
</style>
